import { fetch } from "../lib/network";
import decamelizeKeys from "decamelize-keys";
import AppSettings from "../config";
import { coreService } from "../services/coreService";
import { buildQuery } from "../lib/network";
import MobileApplet from "../types/admin/MobileApplet";

export const getGeneralSettings = (headers: any) => () => {
  return buildQuery(coreService.agencySettingsGeneralSettingsList({ headers }), (response) => {
    return response.data;
  });
};

export const getGeneralSetting = (networkHeaders: any, name: string) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/general/${name}`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putGeneralSettings = (headers: any) => (data: { sealFileId?: string; country?: string }) => {
  return buildQuery(coreService.agencySettingsGeneralSettingsUpdate(data, { headers }), (response) => {
    return response.data;
  });
};

export const getMobileBranding = (headers: any) => {
  return () => {
    return buildQuery(coreService.mobileBrandingList({ headers }), (response) => {
      return response.data;
    });
  };
};

export type MobileBrandingUpdateData = {
  bannerFileId: string | null;
  logoFileId: string | null;
  color: string;
};

export const putMobileBranding = (headers: any) => {
  return ({ bannerFileId = null, logoFileId = null, color }: MobileBrandingUpdateData) => {
    const body = { bannerFileId, logoFileId, color: color.replace(/^#/, "") };
    return buildQuery(coreService.mobileBrandingUpdate(body, { headers }), (response) => {
      return response.data;
    });
  };
};

export const listMobileApplets = (headers: any) => {
  return () => {
    return buildQuery(coreService.mobileAppletsList({ headers }), (response) => {
      return response.data;
    });
  };
};

export const putMobileApplets = (headers: any) => {
  return (applets: MobileApplet[]) => {
    return buildQuery(
      coreService.mobileAppletsUpdate(
        {
          data: applets.map((applet) => {
            const { label, icon, action, order, url, _delete } = applet.attributes;
            return {
              mobilebuttonId: Number(applet.id),
              label,
              icon,
              action,
              mobileOrder: order,
              _delete,
              URL: url,
            };
          }),
        },
        { headers },
      ),
      (response) => {
        return response.data;
      },
    );
  };
};

export const listMobileAppletTypes = (headers: any) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/applets`, {
    method: "GET",
    headers: headers,
  }).then((res) => res.json());

export const getPermitsSettings = (networkHeaders: any) => () =>
  fetch(`${AppSettings.ADMIN_API_URL}/permits`, {
    method: "GET",
    headers: networkHeaders,
  }).then((res) => res.json());

export const putPermitsSettings = (networkHeaders: any) => (body: any) =>
  fetch(`${AppSettings.ADMIN_API_URL}/permits`, {
    method: "PUT",
    headers: networkHeaders,
    body: JSON.stringify({ data: { attributes: decamelizeKeys(body, "-") } }),
  });

export const getCountries = () => {
  return buildQuery(coreService.countriesList(), (response) => {
    return response.data;
  });
};

export const getCountrySetting = (headers: any) => () => {
  return buildQuery(coreService.agencySettingsCountryList({ headers }), (response) => {
    return response.data;
  });
};
